import { useTranslations } from '@vocab/react';
import { Actions, Button, Stack, Text } from 'braid-design-system';

import { TrackOnMount } from 'src/libs/Analytics';

import translations from './.vocab';

export const SuccessDialogContent = ({
  onClose,
  trackSuccessDialogDisplayed,
}: {
  onClose: () => void;
  trackSuccessDialogDisplayed: () => void;
}) => {
  const { t } = useTranslations(translations);
  return (
    <TrackOnMount onMount={trackSuccessDialogDisplayed}>
      <Stack space="large" align="center">
        <Text>{t('Your hiring feedback helps improve SEEK.')}</Text>
        <Actions>
          <Button onClick={onClose} tone="brandAccent">
            {t('Close')}
          </Button>
        </Actions>
      </Stack>
    </TrackOnMount>
  );
};
